import React from "react";
import PropTypes from "prop-types";

import { useBooleanState } from "hooks";

import {
  useAssignServiceTeamAction,
  useClientServiceTeam,
  useClientWorkflows,
} from "./hooks";
import { ClientServiceTeam } from "./ClientServiceTeam";
import {
  EditClientAssignmentModal,
  ManageUserRolesModal,
  ServiceTeamList,
  TeamAssigner,
} from "./components";

function Connector({ clientId }) {
  const [isOpen, openModal, closeModal] = useBooleanState();
  const [isEditAssignmentOpened, openEditAssignment, closeEditAssignment] =
    useBooleanState();
  const { loading, data, numOfFetches, reloadData } =
    useClientServiceTeam(clientId);
  const reloadTasks = useClientWorkflows(clientId);
  const { assignServiceTeam, isAssigning } = useAssignServiceTeamAction(
    clientId,
    () => {
      reloadData();
      reloadTasks();
    }
  );

  return (
    <React.Fragment>
      <ClientServiceTeam
        showLoading={loading && numOfFetches === 0}
        onClickSettings={openModal}
      >
        <TeamAssigner
          currentTeam={data?.serviceTeam}
          onAssign={assignServiceTeam}
          isAssigning={isAssigning}
        />
        <ServiceTeamList
          serviceTeam={data?.serviceTeam}
          serviceRoles={data?.serviceRoles}
          defaultTeam={data?.defaultTeam}
          onMissingAdvisorAssigned={() => {
            reloadTasks();
            reloadData();
          }}
          onClick={openEditAssignment}
        />
      </ClientServiceTeam>
      <ManageUserRolesModal
        open={isOpen}
        onClose={() => {
          reloadData();
          closeModal();
        }}
      />
      {isEditAssignmentOpened && (
        <EditClientAssignmentModal
          clientName={data.name}
          serviceTeam={data?.serviceTeam}
          serviceRoles={data?.serviceRoles}
          defaultTeamMembers={data?.defaultTeam?.serviceTeamMembers}
          onAssign={assignServiceTeam}
          isAssigning={isAssigning}
          onClose={closeEditAssignment}
        />
      )}
    </React.Fragment>
  );
}

Connector.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default Connector;
